<template>
    <div class="container-fluid">
        <div><h3>Clientes</h3></div>
        <form v-on:submit.prevent="create" class="row">
            <div class="form-group col-md-3">
                <input class="form-control" id="name" v-model="name" ref="name" placeholder="Razão Social"/>
                <span class="text-danger">{{ errors.hasOwnProperty('name') ? errors.name[0] : '' }}</span>
            </div>
            <div class="form-group col-md-3">
                <input
                    class="form-control"
                    id="fantasy_name"
                    v-model="fantasy_name"
                    ref="fantasy_name"
                    placeholder="Nome fantasia"
                />
                <span class="text-danger">{{ errors.hasOwnProperty('fantasy_name') ? errors.fantasy_name[0] : '' }}</span>
            </div>
            <div class="form-group col-md-3">
                <span class="customer-since">Cliente desde:</span>
                <date-picker
                    v-model ="start_at"
                    format="DD/MM/YYYY"
                    v-mask="'##/##/####'"
                >
                </date-picker>
                <span class="text-danger">{{ errors.hasOwnProperty('start_at') ? errors.start_at[0] : '' }}</span>
            </div>
            <div class="form-check col-md-2">
                <input class="form-check-input" type="checkbox" id="apportionment" name="apportionment" v-model="apportionment">
                <label class="form-check-label" for="apportionment">
                    Faz Rateio?
                </label>
                <button type="submit" class="btn-save btn btn-success">Salvar</button>
            </div>
        </form>
        <form class="row search">
            <div class="form-group col-md-12">
                <input v-on:keyup="filterCustomers" class="form-control" id="search" v-model="search" ref="search" placeholder="Busca"/>
            </div>
        </form>
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link active"
                    id="active-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#active"
                    type="button" role="tab"
                    aria-controls="active"
                    aria-selected="true"
                >Ativos</button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    id="disabled-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#disabled"
                    type="button"
                    role="tab"
                    aria-controls="disabled"
                    aria-selected="false"
                >Desativados</button>
            </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>Razão Social</th>
                        <th>Nome fantasia</th>
                        <th>Cliente desde</th>
                        <th>Rateio</th>
                        <th width="120px">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="customer in customers" :key="customer.id">
                        <td><input class="form-control hide-input" v-model="customer.name" v-on:blur="edit(customer)"></td>
                        <td><input class="form-control hide-input" v-model="customer.fantasy_name" v-on:blur="edit(customer)"></td>
                        <td>
                            <date-picker
                                v-model ="customer.start_at"
                                format="DD/MM/YYYY"
                                v-mask="'##/##/####'"
                                v-on:change="edit(customer)"
                            >
                            </date-picker>
                        </td>
                        <td><div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="customer.apportionment" v-on:change="edit(customer)">
                            <label class="form-check-label" for="apportionment">
                                Faz Rateio?
                            </label>
                        </div></td>
                        <td>
                            <button class="btn btn-danger" v-on:click="destroy(customer.id)"><i class="far fa-trash-alt"></i></button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="tab-pane fade" id="disabled" role="tabpanel" aria-labelledby="disabled-tab">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>Razão Social</th>
                        <th>Nome fantasia</th>
                        <th>Cliente desde</th>
                        <th>Rateio</th>
                        <th width="120px">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="customer in deletedCustomers" :key="customer.id">
                        <td><input class="form-control hide-input" v-model="customer.name" v-on:blur="edit(customer)"></td>
                        <td><input class="form-control hide-input" v-model="customer.fantasy_name" v-on:blur="edit(customer)"></td>
                        <td>
                            <date-picker
                                v-model ="customer.start_at"
                                format="DD/MM/YYYY"
                                v-on:change="edit(customer)"
                            >
                            </date-picker>
                        </td>
                        <td><div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="customer.apportionment" v-on:change="edit(customer)">
                            <label class="form-check-label" for="apportionment">
                                Faz Rateio?
                            </label>
                        </div></td>
                        <td>
                            <button class="btn btn-success" v-on:click="activate(customer.id)"><i class="fas fa-check"></i></button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import DatePicker from 'vue2-datepicker';

    export default {
        name: 'Customers',
        components: {
          DatePicker
        },
        data () {
            return {
                customers: {},
                name: '',
                fantasy_name: '',
                start_at: new Date(),
                apportionment: false,
                search: '',
                deletedCustomers: {},
                errors: {}
            }
        },
        mounted (){
            this.index()
            this.deleted()
        },
        methods: {
            create () {
                axios.post('/api/customers', {
                    name: this.name,
                    fantasy_name: this.fantasy_name,
                    apportionment: this.apportionment,
                    start_at: this.formatDate(this.start_at)
                }).then(() => {
                    this.name = ''
                    this.fantasy_name = ''
                    this.start_at = new Date()
                    this.apportionment = false
                    this.$refs.name.focus()
                    this.filterCustomers()
                    this.errors = {}
                }).catch((error) => {
                    this.errors = error.response.data.errors;
                })
            },
            index () {
                axios
                    .get('/api/customers?search=' + this.search)
                    .then((response) => {
                        this.customers = response.data.data
                        for (let index in this.customers) {
                            this.customers[index].start_at = new Date(this.customers[index].start_at + ' 12:00:00')
                        }
                    })
            },
            destroy (id) {
                this.$confirm(
                    {
                        message: `Tem certeza que deseja excluir?`,
                        button: {
                            no: 'Não',
                            yes: 'Sim'
                        },
                        callback: confirm => {
                            if (confirm) {
                                axios.delete('/api/customers/' + id)
                                    .then(() => {
                                        this.filterCustomers()
                                    })
                            }
                        }
                    }
                )
            },
            edit (customer) {
                axios.put('/api/customers/' + customer.id, {
                    name: customer.name,
                    fantasy_name: customer.fantasy_name,
                    apportionment: customer.apportionment,
                    start_at: this.formatDate(customer.start_at)
                }).catch(() => {
                    this.$confirm(
                        {
                            title: 'Erro',
                            message: `Já existe um cliente com este nome.`,
                            button: {
                                yes: 'OK',
                            },
                            callback: confirm => {
                                if (confirm) {
                                    this.index()
                                    this.deleted()
                                }
                            }
                        }
                    )
                })

            },
            filterCustomers () {
                this.index()
                this.deleted()
            },
            deleted () {
                axios
                    .get('/api/customers/deleted?search=' + this.search)
                    .then((response) => {
                        this.deletedCustomers = response.data
                        for (let index in this.deletedCustomers) {
                            this.deletedCustomers[index].start_at = new Date(this.deletedCustomers[index].start_at + ' 12:00:00')
                        }
                    })
            },
            activate (id) {
                this.$confirm(
                    {
                        message: `Tem certeza que deseja reativar?`,
                        button: {
                            no: 'Não',
                            yes: 'Sim'
                        },
                        callback: confirm => {
                            if (confirm) {
                                axios.put('/api/customers/activate/' + id)
                                    .then(() => {
                                        this.filterCustomers()
                                    })
                            }
                        }
                    }
                )
            },
            formatDate (date) {
                return (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2));
            }
        }
    }
</script>

<style scoped lang="sass">
    .btn-save
        margin-left: 20px

    #apportionment
        margin-top: 9px

    .search
        margin-top: 15px
        border-top: 1px solid #3c3c3c
        padding: 15px 0

    .customer-since
        margin-right: 10px
</style>
